import EventDispatcher from '@/base/event/event-dispatcher';
import $ from 'jquery';
import { getWH } from '@/base/module/media';



class Base extends EventDispatcher {
    constructor(el, options) {
        super();
        this.screen = getWH(); // 获取展示区域宽高
        this.options = options;
        this.$el = el || $('body'); // 当前元素
        this.list = [];
        setTimeout(function(){
            $(window).scrollTop(0)
        },0);
    }

    // 初始化组件
    initComponents() {
    }

    /** 
     * 绑定事件
     */
    bindEvents() {
        console.log('base >>> bindEvents')
    }

    /**
     * 添加元素
     */
    addItem() {
    }


    /*
     * 根据索引获取元素
     * @param {Number} index 索引
     */
    getItem(index) {
    }
    
}


export default Base;